import React from 'react';
import ReactDOM from 'react-dom';
import './i18n.ts';
import App from './App';
import './index.css';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);

registerServiceWorker();
